// Geocoding service using Open-Meteo Geocoding API
// https://open-meteo.com/en/docs/geocoding-api

export const searchLocations = async (query) => {
  if (!query || query.length < 2) return [];

  try {
    const response = await fetch(
      `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(query)}&count=10&language=en&format=json`
    );

    if (!response.ok) throw new Error('Geocoding API error');

    const data = await response.json();

    if (!data.results) return [];

    // Format results with detailed location info
    return data.results.map(location => ({
      id: location.id,
      name: location.name,
      country: location.country,
      state: location.admin1 || '',
      latitude: location.latitude,
      longitude: location.longitude,
      // Create display name like "Ocean City, Maryland, United States"
      displayName: [
        location.name,
        location.admin1, // State/Province
        location.country
      ].filter(Boolean).join(', '),
      // Create short name like "Ocean City, MD"
      shortName: [
        location.name,
        location.admin1 || location.country
      ].filter(Boolean).join(', ')
    }));
  } catch (error) {
    console.error('Error searching locations:', error);
    return [];
  }
};

// Convert ZIP code to location (US only)
export const zipToLocation = async (zipCode) => {
  try {
    const response = await fetch(`https://api.zippopotam.us/us/${zipCode}`);
    if (!response.ok) throw new Error('Invalid ZIP code');

    const data = await response.json();
    const place = data.places[0];

    return {
      id: `zip_${zipCode}`,
      name: place['place name'],
      state: place['state abbreviation'],
      country: 'United States',
      latitude: parseFloat(place.latitude),
      longitude: parseFloat(place.longitude),
      displayName: `${place['place name']}, ${place['state abbreviation']}, USA`,
      shortName: `${place['place name']}, ${place['state abbreviation']}`,
      zipCode: zipCode
    };
  } catch (error) {
    console.error('Error converting ZIP:', error);
    throw new Error('Invalid ZIP code');
  }
};
